import type { GameEventName, GameEvents } from "../../core/events/GameEvents";
import type { ConditionDefinition } from "./types";

export class ConditionRegistry {
  private readonly definitions = new Map<string, ConditionDefinition>();

  register<K extends GameEventName>(type: string, definition: ConditionDefinition<K>): void {
    this.definitions.set(type, definition as ConditionDefinition);
  }

  get(type: string): ConditionDefinition | undefined {
    return this.definitions.get(type);
  }

  eventFor(type: string): GameEventName | undefined {
    return this.definitions.get(type)?.event;
  }

  matches<K extends GameEventName>(type: string, payload: GameEvents[K], condition: { type: string }): boolean {
    const def = this.definitions.get(type);
    if (!def) throw new Error(`Unknown condition type: ${type}`);
    return def.matches(payload as never, condition);
  }
}
